export default "__VITE_ASSET__c04af424__"